import { PagedResults } from "../models/generics";
import { UserFavorites } from "../types/Structure";
import { FullUserDTO, UserResponseDTO } from "../types/User";
import client from "./axios";

const userUrl = "https://internal-api.getmoveapp.com/api/v1/users";
const hostUserUrl = "https://internal-api.getmoveapp.com/api/v1/admin/users";
//const userUrl = "http://localhost:3000/api/v1/users";
//const hostUserUrl = "http://localhost:3000/api/v1/admin/users";

export const User = {
  sendEmail: (body: {
    sender: string;
    name: string;
    receiver: string;
    title: string;
    text: string;
  }) => client.post(`${userUrl}/send-email`, body),
  getUserInfo: (token: string) => client.get<FullUserDTO>(`${hostUserUrl}`),
  login: (body: { id: string }) =>
    client.post<UserResponseDTO>(`${userUrl}/login`, {
      id: body.id,
    }),
  createUser: (body: {
    name: string;
    familyName: string;
    email: string;
    sportId: number;
  }) => client.post<{ message: string }>(`${hostUserUrl}/create-user`, body),
  reIssueAccessToken: (body: {
    name: string;
    familyName: string;
    email: string;
  }) =>
    client.post<{ message: string }>(
      `${hostUserUrl}/re-issue-access-token`,
      body
    ),
  validateUserToken: (body: { token: string }) =>
    client.post<{ oobCode: string; email: string }>(
      `${userUrl}/validate-token`,
      body
    ),
  confirmUser: (body: { email: string }) =>
    client.post<{ message: string }>(`${userUrl}/confirm-user`, body),
  resetPassword: (body: { email: string }) =>
    client.post<{ message: string }>(`${userUrl}/confirm-reset`, body),
  addPoints: (userId: string, points: number) =>
    client.post<{ giftPoints: number }>(`${userUrl}/add-points/${userId}`, {
      points,
    }),
  // Assegnazione massiva (solo Superadmin): a tutti gli utenti o a una
  // selezione, con notifica personalizzata.
  assignPoints: (body: {
    points: number;
    target: "all" | "selected";
    userIds?: string[];
    title: string;
    message: string;
  }) =>
    client.post<{ recipients: number; pushed: number; points: number }>(
      `${userUrl}/assign-points`,
      body
    ),
  getAllPaginated: (params?: URLSearchParams) =>
    client.get<PagedResults<UserFavorites>>(`${userUrl}/all-paginated`, {
      params,
    }),
};
